var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ve-ring',{attrs:{"data":_vm.chartdata,"settings":_vm.chartSettings,"legend":_vm.legends,"height":_vm.height,"width":"300px","colors":_vm.colors}})}
var staticRenderFns = []

export { render, staticRenderFns }